export enum FormalControlStatus {
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  ACCEPTED_WITH_REMARKS = 'acceptedWithRemarks',
  WAITING = 'waiting',
}
